import { combineEpics } from 'redux-observable';
import { networkResetEpic } from 'data-layer-cr/dist/network';

const rootEpic = combineEpics(networkResetEpic);

export default rootEpic;
